import React from 'react';
import { Zap, DollarSign, Cable, Wifi, Headphones, Gamepad2 } from 'lucide-react';
import { advantages } from '../mockData';

const iconMap = {
  Zap,
  DollarSign,
  Cable,
  Wifi,
  Headphones,
  Gamepad2
};

const AdvantagesSection = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-white to-orange-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-2">
            NOSSAS
          </h2>
          <h2 className="text-4xl md:text-5xl font-bold text-orange-500">
            VANTAGENS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage) => {
            const Icon = iconMap[advantage.icon];
            return (
              <div
                key={advantage.id}
                className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all hover:-translate-y-2 border-2 border-transparent hover:border-orange-500"
              >
                <div className="bg-orange-500 w-16 h-16 rounded-full flex items-center justify-center mb-4">
                  <Icon className="text-white" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{advantage.title}</h3>
                <p className="text-gray-600">{advantage.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default AdvantagesSection;
